export default {
    none : 0,
    inProgress : 1,
    toBeDistributed : 2,
    published : 3,
    toBeApproved : 11
}